module.exports = __webpack_public_path__ + "img/violet_114.cf850193.png";